<canvas [id]="id" width="960px" height="600px"></canvas>

